// extracted by mini-css-extract-plugin
export default {"root":"style_root__kHpbY","ilustration":"style_ilustration__aVfYQ","mainDiv":"style_mainDiv__yHkIF","error":"style_error__I6v6Q","retryBtn":"style_retryBtn__yQKRK"};